import Caption from './Caption'
import Data from './Data'
import Display4 from './Display4'
import ModalHeader from './ModalHeader'
import Link from './Link'
import Status from './Status'

export default {
  Caption,
  Data,
  Display4,
  ModalHeader,
  Link,
  Status,
}



// WEBPACK FOOTER //
// ./src/lib/typography/index.js